"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.config.autotalk.label': 'Czytaj odpowiedzi',
    'chat.config.display.default.prompts.button': 'Nie wiesz co pytać? Wypróbuj nasze sugestie!',
    'chat.config.button.label.text': 'Wyślij wiadomość',
    'chat.config.cancel.button.label.text': 'Anuluj generowanie',
    'chat.config.voice.button.label.text': 'voice input',
    'chat.config.voice.rec.button.label.text': 'Słucham wprowadzania głosowego',
    'chat.config.input.newline.helper': ' dla nowej linii',
    'chat.config.autocomplete.styles.helper': ' dla stylów',
    'chat.config.autocomplete.projects.helper': ' dla projektów',
    'chat.config.autocomplete.knowledge.helper': ' dla wiedzy',
    'chat.config.live_chat.button.label.text': 'Live chat',
    'chat.config.input.placeholder': 'Wpisz swoje pytanie, np. "Jak mogę Ci pomóc?"',
    'chat.config.user.is.bot': 'Asystent wsparcia',
    'chat.config.reset.button.label.text': 'X',
    'chat.config.reset.button.title.text': 'Resetuj bieżące pytanie',
    'chat.config.reset.chat.button.title': 'Resetuj czat',
    'chat.config.copy.response.button.label.text': 'Kopiuj odpowiedź',
    'chat.config.copied.successfully.message': 'Odpowiedź skopiowana!',
    'chat.config.follow.up.questions.label.text': 'Możesz też zapytać...',
    'chat.config.show.thought.process.button.label.text': 'Pokaż proces myślowy',
    'chat.config.hide.thought.process.button.label.text': 'Ukryj proces myślowy',
    'chat.config.loading.indicator.text': 'Proszę czekać. Wyszukujemy i generujemy odpowiedź...',
    'chat.config.loading.text': 'Ładowanie...',
    'chat.config.api.error.message': 'Przepraszamy, mamy problemy. Spróbuj ponownie później.',
    'chat.config.invalid.request.error': 'Nie można wygenerować odpowiedzi na to zapytanie. Zmodyfikuj pytanie i spróbuj ponownie.',
    'chat.config.thought.process.label': 'Proces myślowy',
    'chat.config.support.context.label': 'Kontekst wsparcia',
    'chat.config.reasoning.label': 'Rozumowanie',
    'chat.config.citations.label': 'Dowiedz się więcej:',
    'chat.config.citations.tab.label': 'Cytaty',
    'chat.config.branding.logo.alt': 'Logo marki',
    'chat.config.branding.headline': 'Witamy w asystencie wsparcia naszej marki',
    'chat.config.show.chat.history.label': 'Pokaż historię czatu',
    'chat.config.hide.chat.history.label': 'Ukryj historię czatu',
    'chat.config.chat.history.footer.text': 'Pokazuję ostatnie {MAX_CHAT_HISTORY} rozmów',
    'chat.config.web.search.checkbox.label': 'Użyj wyszukiwania w sieci',
    'chat.config.deep.search.checkbox.label': 'Użyj głębokiego wyszukiwania',
    'chat.config.adv.prompt.checkbox.label': 'Zaawansowane prompty',
    'chat.config.autocomplete.style.selected': 'Styl "{name}" został dodany',
    'chat.config.autocomplete.project.selected': 'Projekt "{name}" został dodany',
    'chat.config.autocomplete.knowledge.selected': 'Wiedza "{name}" została dodana',
    'chat.config.add.kdb.button.label.text': 'Dodaj do bazy wiedzy',
};
